<!-- src/pages/Home.vue -->
<template>
  <header>
    <div class="container" id="maincontent" tabindex="-1">
      <div class="row">
        <div class="col-lg-12 text-center">
          <img class="img-responsive" :src="logo" alt="Organza Logo" />
          <div class="intro-text">
            <span><h2 class="name">Welcome to Organza</h2></span>
            <br />
            <span>a global company employee directory</span>
            <br /><br />
            <span><h3 class="skills">The fabric that holds your organization together</h3></span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import logo from '@/assets/icon/mainpage.png'
</script>

<style scoped>
.img-responsive { max-width: 120px; height: auto; margin-bottom: 1rem; }
/* No more custom styles — your legacy CSS sets .intro-text, .name, .skills, header spacing */
</style>
